module.exports = __webpack_public_path__ + "static/media/3.12cc1dc0.jpg";